import React from "react";

const ExperienceImg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="368"
      height="340"
      viewBox="0 0 368 340"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
    >
      <path d="M365,212H0v-84H365v84Z" fill="#fff" />
      <path
        d="M52.67781,155.77438c-1.96416,0-3.55641,1.59225-3.55641,3.55643s1.59225,3.5564,3.55641,3.5564H312.33719c1.96414,0,3.55643-1.59225,3.55643-3.5564s-1.59229-3.55643-3.55643-3.55643H52.67781Z"
        fill="#2C55E5"
      />
      <path
        d="M52.67781,177.11282c-1.96416-.00415-3.55977,1.58475-3.5639,3.54892-.00415,1.96414,1.58475,3.55975,3.5489,3.5639H216.82214c1.96414,0,3.55643-1.59225,3.55643-3.5564s-1.59229-3.55643-3.55643-3.55643H52.67781Z"
        fill="#2C55E5"
      />
      <path d="M365,212H0v-84H365v84ZM6,206H359v-72H6v72Z" fill="#e5e5e5" />
      <path d="M365,340H0v-84H365v84Z" fill="#fff" />
      <path
        d="M52.67781,283.77438c-1.96416,0-3.55641,1.59225-3.55641,3.55643s1.59225,3.5564,3.55641,3.5564H312.33719c1.96414,0,3.55643-1.59225,3.55643-3.5564s-1.59229-3.55643-3.55643-3.55643H52.67781Z"
        fill="#e6e6e6"
      />
      <path
        d="M52.67781,305.11282c-1.96416-.00415-3.55977,1.58475-3.56392,3.54892-.00414,1.96414,1.58476,3.55975,3.54892,3.5639H216.82214c1.96414,0,3.55643-1.59225,3.55643-3.55643s-1.59229-3.5564-3.55643-3.5564H52.67781Z"
        fill="#e6e6e6"
      />
      <path d="M365,340H0v-84H365v84ZM6,334H359v-72H6v72Z" fill="#e5e5e5" />
      <path d="M368,84H3V0H368V84Z" fill="#fff" />
      <path
        d="M55.67781,27.77438c-1.96414,.00359-3.5535,1.59874-3.54993,3.56288,.00357,1.95909,1.59084,3.54636,3.54993,3.54993H315.33722c1.96417-.00359,3.55353-1.59874,3.54993-3.56288-.0036-1.95909-1.59082-3.54636-3.54993-3.54993H55.67781Z"
        fill="#2C55E5"
      />
      <path
        d="M55.67781,49.11281c-1.96414-.00414-3.55977,1.58476-3.5639,3.5489s1.58476,3.55977,3.5489,3.5639H219.82214c1.96414,.00359,3.5593-1.58577,3.5629-3.54993,.00357-1.96414-1.58578-3.5593-3.54993-3.56288-.00433-.00002-.00864-.00002-.01297,0H55.67781Z"
        fill="#2C55E5"
      />
      <path d="M368,84H3V0H368V84ZM9,78H362V6H9V78Z" fill="#e5e5e5" />
    </svg>
  );
};

export default ExperienceImg;